import type { FeedbackAnswers } from '../app/FeedbackForm.js';

/**
 * Send one post-run feedback row.
 *
 * Fire-and-forget on purpose: the player has already been thanked by the time this
 * resolves, and there is nothing useful to do with a failure. A retry queue exists for
 * leaderboard submissions because a lost run is a lost score; a lost opinion is one row.
 * Never throws, so a dead network cannot take the summary screen down with it.
 */
export interface FeedbackContext {
  playerId: string;
  /** The daily played, or null for free play. */
  date: string | null;
  victory: boolean;
  wavesCleared: number;
  score: number;
  coreHp: number;
  simVersion: number;
  clientVersion: string;
  mutator: string | null;
  towers: { defId: string; star: number; damageDealt: number }[];
}

export async function sendFeedback(
  answers: FeedbackAnswers,
  context: FeedbackContext,
  fetchImpl: typeof fetch = fetch,
): Promise<boolean> {
  try {
    const response = await fetchImpl('/api/feedback', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ ...context, ...answers }),
    });
    return response.ok;
  } catch {
    return false;
  }
}
